import React from 'react'

function Footer() {
  return (
    <footer>
      <div>
        <p>
          <small>Brought to you with &hearts; by your art dealers; Chloe Brown and Elsa Guibert.</small>
        </p>
        <p>
          <small>With special thanks to <a href="www.artsy.net">Artsy</a></small>
        </p>
      </div>
    </footer>
  )
}

export default Footer